export default __webpack_public_path__ + "static/media/sblogo.c903cdad.png";